<template>
  <div class="loader">
    <img src="../assets/img/loader.gif" alt="loader">
  </div>
</template>

<script>
  export default {
    name: 'Loader'
  }
</script>

<style scoped>
  .loader {
    text-align: center;
  }
  img {
    max-width: 60px;
  }
</style>



// WEBPACK FOOTER //
// Loader.vue?16c83f9c